import { styled, Text, TextTag, TokenTextAppearance } from "@volkswagen-onehub/components-core";
import React, { useContext } from "react";
import { LayoutContext } from "../../../context/Layout";
import { SelectedAcodesContext } from "../../../context/SelectedAcodes";
import useTrans from "../../../hooks/use-trans";
import { useFeatureAppContent } from "../../../use-feature-app-content";
import { VehicleThumb } from "./VehicleThumb";

const Wrapper = styled.div`
  width: 100%;
  @media (min-width: 1025px) {
    width: auto;
    padding: 0 ${props => props.theme.size.grid001};
  }
  * {
    scroll-margin-bottom: 100px;
    scroll-margin-top: 124px;
  }
  overflow: visible;
`;

const StyledText = styled(Text)`
  padding: 0 ${(props) => props.theme.size.grid001} 8px;
  @media (min-width: 1025px) {
    padding: 0 0 8px;
  }
`;

const Container = styled.div`
  display: flex;
  -moz-box-align: center;
  align-items: center;
  position: relative;
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: visible;
  scrollbar-width: none;
  column-gap: ${({theme}) => theme.size.static200};
  padding: 4px;
  mask-image: linear-gradient(to right, transparent, black var(--size-grid001) calc(100% - var(--size-grid001)), transparent);
  > :first-child {
    margin-inline-start: ${props => props.theme.size.grid001};
  }
  > :last-child {
    margin-inline-end: ${props => props.theme.size.grid001};
  }

  @media (min-width: 1025px) {
    mask-image: initial;
    row-gap: 16px;
    > :first-child {
      margin-inline-start: 0;
    }
  }
`;

export const VehicleSelection = () => {

  const { acodes, setAcode, data: vehicles } = useContext(SelectedAcodesContext);
  const { context } = useFeatureAppContent();
  const { columnCount } = useContext(LayoutContext)
  const { sections: { dimensions: { direction }} } = useTrans();

  return (
    vehicles?.length
    ? <Wrapper>
      <StyledText tag={TextTag.p} appearance={TokenTextAppearance.copy100}>
        { direction.replace("%%count%%", columnCount) }
      </StyledText>
      <Container>
        { vehicles?.map((vehicle, i) => {
          const isSelected = acodes.includes(vehicle.acode);
          const src = vehicle.images.filter(x => x.context === `${context}-thumb`)?.[0]?.url!
          if (src) {
            return (
              <VehicleThumb
                key={i}
                acode={vehicle.acode}
                model={vehicle.model}
                src={src}
                isSelected={isSelected}
                setAcode={setAcode}
                selectionLength={vehicles.length}
              />
            );
          }
          return null;
        })}
      </Container>
    </Wrapper>
    : null
  );
};
